import { useMemo } from "react";
import { useQuery, gql } from "@apollo/client";
import get from "lodash/get";

const GET_GATEKEEPER = gql`
	query getGatekeeper($checkName: GatekeeperName!) {
		session {
			hasGatekeeper(name: $checkName)
		}
	}
`;

/**
 * Get the value of a gatekeeper check.
 * @param {string} checkName - the gatekeeper you'd like to check.
 * @param {object} [options] - useQuery options.
 * @returns {[boolean, Object]} [gatekeeper value, useQuery response]
 */
function useGatekeeper(checkName, options = {}) {
	// Fetch the Gatekeeper Check value from gql.
	const res = useQuery(GET_GATEKEEPER, { variables: { checkName }, ...options });
	const hasGatekeeper = get(res, "data.session.hasGatekeeper");

	// Memoized so the array doesn't change unless the contents change.
	return useMemo(() => [hasGatekeeper, res], [hasGatekeeper, res]);
}

export default useGatekeeper;



// WEBPACK FOOTER //
// ./src/shared/hooks/useGatekeeper.js